import { render } from "./ShootingPinTable.vue?vue&type=template&id=3226b3a6&scoped=true&ts=true"
import script from "./ShootingPinTable.vue?vue&type=script&lang=ts"
export * from "./ShootingPinTable.vue?vue&type=script&lang=ts"

import "./ShootingPinTable.vue?vue&type=style&index=0&id=3226b3a6&lang=scss&scoped=true"

import exportComponent from "/www/public/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3226b3a6"]])

export default __exports__